import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './styles/Footer.css';
import logoImage from '../../../assets/images/Logo/White-Logo.png';

const Footer = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer__main">
        <div className="footer__container">
          {/* Column 1 — Company info */}
          <div className="footer__column footer__column--company">
            <Link to="/" className="footer__logo">
              <img src={logoImage} alt="ALG Data Guard" className="footer__logo-img" />
              <span className="footer__logo-text">ALG Data Guard</span>
            </Link>

            <address className="footer__address">
              <strong>Corporate Headquarters</strong>
              <p>7111 Syntex Dr</p>
              <p>Mississauga, ON L5N 8C3</p>
              <p>Canada</p>
            </address>

            <Link to="/contact" className="footer__contact-btn">
              Contact Us
              <span className="footer__arrow">▶</span>
            </Link>

            <p className="footer__tagline">
              Get in touch for a customised IT strategy today.
            </p>

            <div className="footer__contact-info">
              <a href="mailto:info@algdataguard.com" className="footer__contact-link">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round" aria-hidden="true">
                  <rect x="2" y="4" width="20" height="16" rx="2"/>
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                </svg>
                info@algdataguard.com
              </a>

              {/* CHANGED: was href="tel:+14167645991" with mismatched text
                  "+1-888-850-4349" — fixed to the correct toll-free number,
                  href and text now match */}
              <a href="tel:+18888504349" className="footer__contact-link">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round" aria-hidden="true">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.15 3.4 2 2 0 0 1 3.11 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 16z"/>
                </svg>
                Toll Free: 1-888-850-4349
              </a>

              {/* CHANGED: was href="tel:+14167645928" labeled "Fax: 416-764-5928"
                  (fax icon) — now the second phone number, phone icon to match,
                  no longer using the --fax modifier class */}
              <a href="tel:+14167645991" className="footer__contact-link">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round" aria-hidden="true">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.15 3.4 2 2 0 0 1 3.11 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 16z"/>
                </svg>
                +1-416-764-5991
              </a>
            </div>
          </div>

          {/* Columns 2 & 3 are commented out in the original — preserved here */}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer__bottom">
        <div className="footer__bottom-container">
          <div className="footer__bottom-left">
            <p className="footer__copyright">
              © ALG Data Guard 2026. All rights reserved.
            </p>
            {/* NEW */}
            <p className="footer__canadian-note">
              🇨🇦 Canadian Owned and Operated
            </p>
          </div>

          {/* Social icons */}
          <div className="footer__social">
            <a
              href="https://linkedin.com/in/alg-dataguard-48838a37a"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__social-link"
              aria-label="LinkedIn"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" className="footer__social-icon" aria-hidden="true">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>

            <a
              href="https://x.com/ALGDataguard"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__social-link"
              aria-label="X (Twitter)"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" className="footer__social-icon" aria-hidden="true">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>

            <a
              href="https://youtube.com/@algdataguard"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__social-link"
              aria-label="YouTube"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" className="footer__social-icon" aria-hidden="true">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Closing tagline */}
        <div className="footer__tagline-bottom">
          <p>
            We look forward to partnering with you and supporting the growth of your business.
            Let&apos;s achieve success together.
          </p>
        </div>
      </div>

      {/* Scroll-to-top */}
      <button
        onClick={scrollToTop}
        className={`footer__scroll-top ${showScrollTop ? 'footer__scroll-top--visible' : ''}`}
        aria-label="Scroll to top"
      >
        ↑
      </button>
    </footer>
  );
};

export default Footer;